import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import ScheduleGradeAircraftLineAlternate from './ScheduleGradeAircraftLineAlternate';

import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeTrainingEditTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      grade_schedule_trainings: null,
      edit_mode: false,
      staffs_list: [],
      width_table: '100%',
      width_table_tbody: '100%',
      aircrafts_list: [],
      remaining_staffs_list: null,
    };
    this.add = this.add.bind(this);
    this.cloneDayAlternate = this.cloneDayAlternate.bind(this);
    this.changeDateTypeAlternate = this.changeDateTypeAlternate.bind(this);
    this.deleteLineAlternate = this.deleteLineAlternate.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeRegime(name, event) {
    var self = this;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    Object.keys(self.props.schedule_used_regimes).map(function(k) {
      var sur = self.props.schedule_used_regimes[k];
      if (sur.id === event.value) {
        self.setState({start_day: sur.start_day_str});
      }
    })
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((Array.isArray(newProps.grade_schedule_trainings))) {
      this.setState({
        grade_schedule_trainings: newProps.grade_schedule_trainings,
      });

      var total_days = 0;
      Object.keys(this.props.schedule_days).map(function(k) {
        total_days = total_days + 1;
      })

      var total_days = 0;
      Object.keys(this.props.schedule_days).map(function(k) {
        total_days = total_days + 1;
      })
      var total_width_days = (70 * total_days);
      var width_table = 125 + 78 + 37 + 57 + 57 + 42 + 180 + 58 + 58 + total_width_days;
      var width_table_tbody = width_table + 16;
      width_table = width_table + 'px';
      width_table_tbody = width_table_tbody + 'px';
      this.setState({width_table: width_table});
      this.setState({width_table_tbody: width_table_tbody});

      
    }
    if((this.state.loaded === 0 && Array.isArray(newProps.remaining_staffs_list)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        remaining_staffs_list: newProps.remaining_staffs_list,
        schedule_grade_id: newProps.schedule_grade_id,
        types_list: newProps.types_list,
        loaded: 1,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});
  }

  add (event) {
    event.preventDefault();
    if(this.state.edit_mode) {
      this.props.handleAlert(this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.naoEPossivelAdicionarColaboradorEmModoDeEdicao, 'info', 'open');
    } else {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        schedule_grade_id: this.state.schedule_grade_id,
        staff_id: this.state.staff_id,
        type: 'treinamentos',
      };
  
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/adicionar/treinamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  deleteLineAlternate(schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var confirm = window.confirm(this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.removerTripulante);
      if (confirm) {
        var grade = {grade_schedule_trainings: [...self.state.grade_schedule_trainings]};
        var grade_prov = [...self.state.grade_schedule_trainings];
        Object.keys(grade.grade_schedule_trainings).map(function(k) {
          if(typeof grade.grade_schedule_trainings[k] !== 'undefined') {
            if(grade.grade_schedule_trainings[k].sgas_id === schedule_grade_aircraft_staff_id) {
              grade_prov.splice(k, 1);
            }
          }
        })

        grade.grade_schedule_trainings = [...grade_prov];
        self.props.updateDataEditMode(grade);
      }
    }  
  }

  changeDateTypeAlternate (schedule_grade_aircraft_staff_id, date, type) {
    var self = this;
    if(self.state.edit_mode) {
      var grade = {grade_schedule_trainings: [...self.state.grade_schedule_trainings]};
      var grade_prov =[...self.state.grade_schedule_trainings];

      Object.keys(grade.grade_schedule_trainings).map(function(k) {
        if(grade.grade_schedule_trainings[k].sgas_id === schedule_grade_aircraft_staff_id) {
          grade_prov[k].days[date].type = type;
        }
      })

      grade.grade_schedule_trainings = [...grade_prov];
      self.props.updateDataEditMode(grade);
    }
  }

  cloneDayAlternate (direction, type, date, schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var iso_date = date.split('/');
      iso_date = iso_date[2] + '-' + iso_date[1] + '-' + iso_date[0] + 'T15:00:00';

      var modifier = 1;
      if(direction === 'left') {
        modifier = -1;
      }

      var next_date = new Date(iso_date);
      var next_date_string  = date;
      var next_date_iso = iso_date;
      var current_day = 0;
      var day = '';
      var month = '';
      var year = '';

      var grade = {grade_schedule_trainings: [...self.state.grade_schedule_trainings]};
      var grade_prov =[...self.state.grade_schedule_trainings];

      Object.keys(grade.grade_schedule_trainings).map(function(k) {
        if(typeof grade.grade_schedule_trainings[k] !== 'undefined') {
          if(grade.grade_schedule_trainings[k].sgas_id === schedule_grade_aircraft_staff_id) {
            if(typeof grade_prov[k].days[next_date_string] !== 'undefined') {
              var found = false
              while(!found && typeof grade_prov[k].days[next_date_string] !== 'undefined') {
                if(grade_prov[k].days[next_date_string].type === grade_prov[k].days[date].type) {
                  current_day = next_date.getDate();
                  next_date = new Date(next_date_iso);
                  next_date.setDate(current_day+modifier);
                  
                  next_date_string  = next_date.toLocaleDateString('en-US');
                  next_date_string = next_date_string.split('/');
                  day = (next_date_string[1].length == 1) ? '0'+next_date_string[1] : next_date_string[1];
                  month = (next_date_string[0].length == 1) ? '0'+next_date_string[0] : next_date_string[0];
                  year = next_date_string[2];
                  
                  next_date_string = day+'/'+month+'/'+year;
                  next_date_iso = year+'-'+month+'-'+day + 'T15:00:00';
                } else {
                  found = true;
                  grade_prov[k].days[next_date_string].type = type;
                }
              }
            }
          }
        }
      })

      grade.grade_schedule_trainings = [...grade_prov];
      self.props.updateDataEditMode(grade);
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.formulario.Funcionario}:</label>
          <Select
            className="form-field-name"
            name="staff_id"
            value={this.state.staff_id}
            searchable={true}
            placeholder={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.formulario.placeholder.SelecionarFuncionario}
            onChange={this.handleSelectChange.bind(this, 'staff_id')}
            options={this.state.remaining_staffs_list}
          />
        </div>
      </div>
    </div>
    <hr/>
    <div className="form-group">
      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.formulario.botaoAdicionarAEscala}</button>
    </div>
  </form>
  <hr/>
  <p className="bg-info" style={{padding: 10}}><i className="fa fa-fw fa-warning"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.casoSejaSelecionadaUmComunicadoDeTreinamentoNaSigla}</p>
  <hr/>
  <h3 className="page-title pull-left">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.tituloEscala}</h3>
  <div className="pull-right">
    {!self.state.edit_mode && <button className="btn button-inline btn-primary" onClick={() => self.props.toggleEditMode()}><i className="fa fa-pencil"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.botaoAbrirEdicao}</button>}
    {self.state.edit_mode && <button className="btn button-inline btn-success" onClick={() => self.props.saveGrade()}><i className="fa fa-save"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.botaoSalvarEdicao}</button>}
    {self.state.edit_mode && <button className="btn button-inline btn-danger" onClick={() => self.props.resetGrade()}><i className="fa fa-trash"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.botaoDescartarMudancas}</button>}
  </div>
  <div className="clearfix"></div>
  {(this.state.grade_schedule_trainings === null || typeof this.state.grade_schedule_trainings === 'undefined') ?  ''
  :
  <div className="table-schedule-container-simple">
    <hr/>
      <table className="table table-schedule-alternate table-bordered">
        <tbody id="suppliers-certifications">
        <tr>
          <td className="text-center table-schedule-sticky table-schedule-main-del-alternate"></td>
          <td className="text-center table-schedule-sticky table-schedule-main-name-alternate">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.tabela.Nome}</td>
          <td className="text-center table-schedule-sticky table-schedule-main-inscription-alternate">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.tabela.Matricula}</td>
          <td className="text-center table-schedule-sticky table-schedule-main-designation-alternate">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.tabela.Designacao}</td>
          {Object.keys(self.props.schedule_days).map(function(k) {
            var day = self.props.schedule_days[k];
            return(
              <td className="table-schedule-main-day-alternate">{day.weekday}</td>
            );
          })}
        </tr>
        <tr>
          <td className="text-center table-schedule-sticky table-schedule-main-del-alternate"></td>
          <td className="text-center table-schedule-sticky table-schedule-main-name-alternate"></td>
          <td className="text-center table-schedule-sticky table-schedule-main-inscription-alternate"></td>
          <td className="text-center table-schedule-sticky table-schedule-main-designation-alternate"></td>
          {Object.keys(self.props.schedule_days).map(function(k) {
            var day = self.props.schedule_days[k];
            return(
              <td className="table-schedule-main-day-alternate">{day.day_simple}</td>
            );
          })}
        </tr>
        {Object.keys(self.state.grade_schedule_trainings).map(function(k) {
          var sgas = self.state.grade_schedule_trainings[k];
          return(
            <ScheduleGradeAircraftLineAlternate schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id}  updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} types_list={self.props.types_list} sgas={sgas} staffs_list={self.props.staffs_list} schedule_days={self.props.schedule_days} initials_colors={self.props.initials_colors} toggleEditMode={self.props.toggleEditMode} edit_mode={self.state.edit_mode} generatePersonalAlerts={self.props.generatePersonalAlerts} changeDateType={self.changeDateTypeAlternate} deleteLineAlternate={self.deleteLineAlternate} cloneDay={self.cloneDayAlternate} zoom_level={4} />
            );
        })}
      </tbody>
    </table>
  </div>
  }
</div>
    );
  }
}

export default ScheduleGradeTrainingEditTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeTrainingEditTab.js